import { render, staticRenderFns } from "./FeedbackMenuV2026.vue?vue&type=template&id=809166aa&scoped=true"
import script from "./FeedbackMenuV2026.vue?vue&type=script&lang=js"
export * from "./FeedbackMenuV2026.vue?vue&type=script&lang=js"
import style0 from "./FeedbackMenuV2026.vue?vue&type=style&index=0&id=809166aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809166aa",
  null
  
)

export default component.exports